export const PAGE_TYPE = {
  presellPage: 'presellPage',
  leadPage: 'leadPage',
  checkoutPage: 'checkoutPage',
  upsellPage: 'upsellPage1',
  thankyouPage: 'thankyouPage',
};
